import http from "./http.config";

export type DemoRequestPayload = Record<string, unknown>;

export const sendDemoRequest = (payload: DemoRequestPayload) =>
  http.post("/demo-requests/store", payload).then((res) => res.data);
